import { useState, useEffect } from "react";
import { GlobalSecondaryButton, FilterButton } from "../../pages/styles";
import FilterMenu from "../../components/FilterMenu";
import { Filter } from "./types";

interface FilterOption {
  name: string;
  displayName: string;
  type: string;
  enumValues: string[];
}

interface FilterWrapperProps {
  filterOptions: FilterOption[];
  onApplyFilters?: (filters: Filter[]) => void;
  disabled: boolean;
}

const defaultFilter = {
  name: null,
  displayName: null,
  operator: null,
  enumValues: [],
  value: "",
};

const defaultFilters = [defaultFilter];

export const FilterWrapper = ({
  filterOptions,
  onApplyFilters = () => {},
  disabled,
}: FilterWrapperProps) => {
  const [filters, setFilters] = useState<Filter[] | null>(null);
  const [openFilterMenu, setOpenFilterMenu] = useState<boolean>(false);
  const hasFilters = filters && filters.length > 0;

  const handleOpenFilterMenu = () => setOpenFilterMenu(true);

  const handleClearFilters = () => {
    setFilters(null);
    onApplyFilters([]);
  };

  const handleApplyFilters = () => {
    onApplyFilters(filters ?? defaultFilters);
    setOpenFilterMenu(false);
  };
  const handleCancelApplyFilters = () => setOpenFilterMenu(false);

  useEffect(() => {
    onApplyFilters(filters ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <>
      <FilterMenu
        moduleName="samples"
        open={openFilterMenu}
        setOpen={undefined}
        applyBtnAction={handleApplyFilters}
        cancelButtonAction={handleCancelApplyFilters}
        filteringInfo={filterOptions}
        appliedFilters={filters ?? defaultFilters}
        setAppliedFilters={setFilters}
        children={undefined}
      />
      <FilterButton
        disabled={disabled || filterOptions.length === 0}
        variant="contained"
        filtered={filters && filters.length > 0}
        onClick={handleOpenFilterMenu}>
        Filters
      </FilterButton>

      {hasFilters && !disabled && (
        <GlobalSecondaryButton
          variant="contained"
          style={{ marginLeft: "1rem" }}
          onClick={handleClearFilters}>
          Clear Filters
        </GlobalSecondaryButton>
      )}
    </>
  );
};
